<template>
  <v-expansion-panels v-if="$$debug.enabled" v-model="expansionValue" :flat="!elevate" class="my-1">
    <v-expansion-panel>
      <v-expansion-panel-header class="caption">
        <div>
          {{ label }}
          <v-icon right x-small>mdi-code-json</v-icon>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <debug-card-content :font-size="fontSize" :value="value"/>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script lang="ts">
import Vue from 'vue';
import DebugCardContent from '@/components/common/debugCard/debugCard__content.vue';

export default Vue.extend({
  components: {DebugCardContent},
  props: {
    label: {
      type: String as () => any,
      default: 'Debug',
    },
    value: {
      type: Object as () => any,
      required: true,
    },
    fontSize: {
      type: Number,
      required: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    expansionValue: null as number | null,
  }),
  computed: {
    elevate(): boolean {
      return typeof this.expansionValue === 'number';
    },
  },
  mounted() {
    if (this.open) {
      this.expansionValue = 0;
    }
  },
});
</script>
